import * as React from 'react';
import { Col } from 'reactstrap';

interface IHomeDomainCardProps {
  label: string;
  src: string;
  // text: string;
  text_1: string;
  text_2: string;
  text_3: string;
  text_4: string;
}

export const HomeDomainCard: React.SFC<IHomeDomainCardProps> = ({
  label,
  src,
  // text,
  text_1,
  text_2,
  text_3,
  text_4,
}) => (
  <Col
  lg='4'
    md='6'
    xs='12'
    className='d-flex flex-column align-items-center text-center pb-3'
  >
    <div
      className={`home-domain-${src} rounded`}
      style={{ width: '160px', height: '160px' }}
    />
    <span className='text-bold mt-3' style={{ fontSize: '18px' }}>
    <strong>{label}</strong>
    </span>
    <p className='m-1' style={{ width: '240px' }}>
      {/* {text} */}
      {text_1} <br/>
      {text_2} <br/>
      {text_3} <br/>
      {text_4}
    </p>
  </Col>
);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeDomain/HomeDomainCard.tsx